import { PARTNER_MANAGER_DETAILS_TYPE } from './enums';

const INTERNAL_PARTNER_MANAGER = [
    PARTNER_MANAGER_DETAILS_TYPE.ADMIN,
    PARTNER_MANAGER_DETAILS_TYPE.ADMIN_READ_ONLY,
];
export {
    INTERNAL_PARTNER_MANAGER,
};
